class Constant {
  // static BASE_URL = "https://uatapi.policicue.com/";
  static BASE_URL = "http://localhost:1051/";
  // static PROD_URL = "https://api.policicue.com/";
  // static BASE_URL = "https://api.policicue.com/";
  // static BASE_URL = "http://prod-web-api-env.eba-jchcgvgt.ap-south-1.elasticbeanstalk.com/"
}

export default Constant;
